import { z } from "zod"

export const envSchema = z.object({
	MODE: z.enum(["production", "development", "test"]).default("production"),
	VITE_APP_API_HOST: z.string(),
	VITE_ENABLE_API_DELAY: z
		.string()
		.transform((value) => value === "true")
		.optional(),
	VITE_GOOGLE_MAPS_KEY: z.string(),
	VITE_PUBLIC_DEV_LATITUDE: z.string().optional(),
	VITE_PUBLIC_DEV_LONGITUDE: z.string().optional(),
	VITE_CONTACTS_API_URL: z.string(),
	VITE_IMAGE_BUCKET_URL: z.string().optional().default("https://midia.primi.com.br"),
})

export const env = envSchema.parse(import.meta.env)
